const announcements = {
  path: 'announcements/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/announcements'], resolve)
}
export default announcements



// WEBPACK FOOTER //
// ./src/router/pages/student_user/announcements/index.js